<template>
    <ModalFormCard :action="action" :submittedCallback="submittedCallback" class="modal-default">
        <template #title>Mark {{ $help.pluralize(options.dataName, update.data.length) }} as lost</template>

        <template #default="{ saving, errors }">
            <input type="hidden" name="ids" :value="update.data" />
            <input type="hidden" name="type" :value="modelType" />
            <input type="hidden" name="status" :value="2" />
            <input type="hidden" name="reason" :value="update.reason" />
            <input type="hidden" name="table_multiselect_update" :value="update?.tableMultiselectUpdate" />

            <Select
                v-model:value="update.reason"
                :options="reasons"
                class=""
                name="reason"
                label="Reason"
                placeholder="Choose the reason"
                selectClass="bg-grey-300"
            />

            <Textarea
                v-model:value="update.description"
                name="description"
                label="What was the reason for losing this lead?"
                placeholder="Explain the reason"
                class="mt-4" rows='6'
                v-if='update.reason == "Other"'
            />

            <div class="modal-buttons">
                <ButtonSaving :disabled="saving" class="button-black default"> Mark as lost </ButtonSaving>

                <button class="button-purple" type="button" @click="$emit('close')">Cancel</button>
            </div>
        </template>
    </ModalFormCard>
</template>

<script>
// import Lead from "~/models/lead.js";
import Modal from '~/mixins/modal.js'

export default {
    mixins: [Modal],

    created() {
        // this.setup(Lead);
    },

    methods: {
        submittedCallback(res) {
            if (this.update.tableMultiselectUpdate != null) {
                this.$event.$emit('multiSelectCompleted', res.updated)
            }

            this.$event.$emit('modal-form-completed')
            this.$emit('close')
        },
    },

    computed: {
        action() {
            if (this.options.modelType != 2) {
                return '/actions/lead-set-status'
            }

            return '/lost'
        },

        update() {
            return this.options
        },

        ai() {
            return this.editingModel.ai_current != null ? JSON.parse(this.editingModel.ai_current.body) : false
        },

        reasons() {
            if (this.options.modelType == 2) {
                return [
                    { value: 'Budget constraints' },
                    { value: 'Didn’t pass qualification checklist' },
                    { value: 'No immediate need or priority' },
                    { value: 'Inaccurate or outdated contact info' },
                    { value: 'Already using Google Ads themselves' },
                    { value: 'Decision maker unavailable' },
                    { value: 'Already in contract with another supplier' },
                    { value: 'Lost to competitor' },
                    { value: 'Lack of timely follow up' },
                    { value: 'Lead fatigue (Overwhelmed by too much outreach)' },
                    { value: 'Sales rep churn or transition' },
                    { value: 'Business closing' },
                    { value: 'Other' },
                ]
            }

            return [
                { value: 'Lost to competition' },
                { value: 'Poor follow up' },
                { value: 'We were too expensive' },
                { value: 'We didnt want the work' },
                { value: 'Service not offered' },
                { value: 'Timing issue' },
                { value: 'Problem customer' },
                { value: 'Other' },
            ]
        }
    },
}
</script>
